/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the separator row for?`)
};

const es_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Para qué sirve la fila separadora?`)
};

const de_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wofür ist die Trennzeile?`)
};

const nl_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarvoor dient de scheidingsrij?`)
};

const fr_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quoi sert la ligne de séparation ?`)
};

const it_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cosa serve la riga separatrice?`)
};

const pt_br2_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para que serve a linha separadora?`)
};

const pt_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para que serve a linha de separação?`)
};

const ja_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セパレータ行は何のためにあるのですか？`)
};

const zh_mt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分隔行有什么作用？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_faq1_q", locale)
	if (locale === "en") return en_mt_faq1_q(inputs)
	if (locale === "es") return es_mt_faq1_q(inputs)
	if (locale === "de") return de_mt_faq1_q(inputs)
	if (locale === "nl") return nl_mt_faq1_q(inputs)
	if (locale === "fr") return fr_mt_faq1_q(inputs)
	if (locale === "it") return it_mt_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_mt_faq1_q(inputs)
	if (locale === "pt") return pt_mt_faq1_q(inputs)
	if (locale === "ja") return ja_mt_faq1_q(inputs)
	return zh_mt_faq1_q(inputs)
};